import { formatDateOnlyLocal } from '@erp/shared-utils';

import { stripDownloadExtension } from './rebateExportFilename';

export function rebateMultiTableDownloadFilename(
  filename: string,
  format: 'csv' | 'xlsx',
  now: Date = new Date(),
): string {
  const stamp = formatDateOnlyLocal(now);
  const extension = format === 'xlsx' ? 'xlsx' : 'csv';
  return `${stripDownloadExtension(filename)}-${stamp}.${extension}`;
}

export function rebateMultiTableFinalFilename(
  filename: string,
  format: 'csv' | 'xlsx',
): string {
  const extension = format === 'xlsx' ? 'xlsx' : 'csv';
  return `${stripDownloadExtension(filename)}.${extension}`;
}
